<template>
<div class="recomDialog">
    <el-dialog @close="cancel" title="推荐排序" :visible.sync="dialogVisible">
        <div class="chapter_item_content" v-for="(obj, index) in tableData" :key="index" :draggable="isDrag"
             @dragstart="handleDragStart($event, obj)"
             @dragover.prevent="handleDragOver($event, obj)"
             @dragenter="handleDragEnter($event, obj)"
             @dragend="handleDragEnd($event, obj)"
             @dragleave="handleDragleave($event, obj, index)">
            <div class="box">
                <div class="left">
                    <img class="img" v-lazy="obj.coverurl" alt="">
                    <span class="subject text-ellipse">{{obj.subject}}</span>
                </div>
                <i class="right handle_icon" @mouseover="mouseOver" @mouseleave="mouseLeave"></i>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="handleSure">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {getAllCourseByInnerRecom, updateInnerRecomSortInfo} from 'api/curriculumApi'
import {mapActions} from 'vuex'

export default {
    name: 'recomDialog',
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            dragging: {},
            isDrag: false
        }
    },
    mounted() {
    },
    methods: {
        cancel() {
            this.dialogVisible = false
        },
        openDialog() {
            this.dialogVisible = true
            this._getList()
        },
        handleSure() {
            let list = []
            this.tableData.forEach(obj => {
                list.push(obj.innerid)
            })
            this._save(list)
        },
        mouseOver () {
            this.isDrag = true
        },
        // 拖拽图标鼠标移出
        mouseLeave () {
            this.isDrag = false
        },
        handleDragStart(even, item) {
            this.dragging = item
        },
        handleDragEnd(e, item) {
            this.dragging = null
        },
        //首先把div变成可以放置的元素，即重写dragenter/dragover
        handleDragOver(e) {
            e.dataTransfer.dropEffect = 'move' //在dragenter中针对放置目标来设置!
        },
        handleDragEnter(e, item) {
            if (this.isDrag) {
                if (e.target.className == "box") {
                    e.target.style.background = "#EAEEF4"
                }
                e.dataTransfer.effectAllowed = 'move'//为需要移动的元素设置dragstart事件
                if (item === this.dragging) {
                    return
                }
                const newItems = [...this.tableData]
                const src = newItems.indexOf(this.dragging)
                const dst = newItems.indexOf(item)
                newItems.splice(dst, 0, ...newItems.splice(src, 1))
                this.tableData = newItems
            }
        },
        handleDragleave(e, item, index) { // 当拖动元素离开可放置目标节点，重置其背景
            if (e.target.className == "box") {
                e.target.style.background = "#fff"
            }
        },
        _save(list) {
            this.setLoading(true)
            updateInnerRecomSortInfo({
                data: {inneridlist: list.join(',')},
                success: data => {
                    this.$message.success('修改排序成功')
                    this.setLoading(false)
                    this.cancel()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getAllCourseByInnerRecom({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.recomDialog {
    .box{
        display: flex;
        padding: 0 10px;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        .left{
            display: flex;
            align-items: center;
            .subject{
                width: 400px;
            }
            .img{
                width: 48px;
                height: 48px;
                margin-right: 10px;
            }
        }
    }
    .box{
        border-bottom: 1px solid #DCDFE6;
    }
    .handle_icon {
        background-image: url('../../../../common/images/cms/drag.png');
        background-size: 24px 24px;
        width: 24px;
        height: 24px;
        cursor: pointer;
    }
    .handle_icon:hover {
        background-image: url('../../../../common/images/cms/drag_hover.png');
    }
}
</style>
